import script from "./ScreenshotWindow.vue?vue&type=script&setup=true&lang=ts"
export * from "./ScreenshotWindow.vue?vue&type=script&setup=true&lang=ts"

import "./ScreenshotWindow.vue?vue&type=style&index=0&id=9ec861e8&scoped=true&lang=css"

import exportComponent from "/Users/ra1to/Desktop/web_frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9ec861e8"]])

export default __exports__